// extracted by mini-css-extract-plugin
module.exports = {"body":"CustomizedTabs_body__H_-Uq","desc":"CustomizedTabs_desc__1fm1y"};